
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { StyleClassModule } from 'primeng/styleclass';
import { AvatarModule } from 'primeng/avatar';
import { LayoutService } from '../../service/layout.service';
import { StorageService } from '../../../core/services/storage.service';
import { Usuario } from '../../../core/models/usuario';
import { IntranetSeguridadService } from '../../../core/services/intranet-seguridad.service';


@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
    styleUrl: './app.topbar.component.scss',
    imports: [RouterModule, CommonModule, StyleClassModule, AvatarModule]
})
export class AppTopbar implements OnInit, OnDestroy {
    usuario: Usuario | null = null
    menuOpen: boolean = false;
    erroresPendientes = 0;
    private monitoreoIntervalo?: ReturnType<typeof setInterval>;

    constructor(
        public layoutService: LayoutService,
        private storageService: StorageService,
        private readonly seguridad: IntranetSeguridadService,
        private readonly router: Router
    ) {
        this.usuario = storageService.storageGet("usuario") ?? null
    }

    ngOnInit(): void {
        this.actualizarErroresPendientes();
        this.monitoreoIntervalo = setInterval(() => this.actualizarErroresPendientes(), 60000);
    }

    ngOnDestroy(): void {
        if (this.monitoreoIntervalo) clearInterval(this.monitoreoIntervalo);
    }

    toggleMenu() {
        this.menuOpen = !this.menuOpen;
    }

    toggleDarkMode() {
        this.layoutService.layoutConfig.update((state) => ({ ...state, darkTheme: !state.darkTheme }));
    }

    abrirMonitoreo(): void {
        this.router.navigate(['/reportes/logsapp']);
    }

    private actualizarErroresPendientes(): void {
        this.seguridad.post<{ pendientes: number }>('reportes/monitoreo/resumen').subscribe({
            next: (respuesta) => this.erroresPendientes = respuesta.isSuccess ? respuesta.value?.pendientes ?? 0 : 0,
            error: () => this.erroresPendientes = 0,
        });
    }
}
